<div class="lsc" *ngIf="changed">
  <span class="lsc-label">Estado del arrendamiento</span>
  <p-tag [value]="before ?? ''" [severity]="severity(before)"></p-tag>
  <i class="fa-solid fa-arrow-right-long" aria-hidden="true"></i>
  <p-tag [value]="after ?? ''" [severity]="severity(after)"></p-tag>
</div>
